// extracted by mini-css-extract-plugin
export var callCard = "_oi-0";
export var callMessageButton = "_oi-1";
export var helpIcon = "_oi-3";
export var helpIconContainer = "_oi-4";
export var verticalDivider = "_oi-2";